import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

function CarControlDescription({ digitalCertificate }) {
  const { technicalConditions } = digitalCertificate
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="h3" gutterBottom>
        {t('carControl.description')}
      </Typography>
      <Box sx={{ py: 2 }}>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
          {technicalConditions.description}
        </Typography>
      </Box>
    </>
  )
}

CarControlDescription.propTypes = {
  digitalCertificate: PropTypes.object,
}

CarControlDescription.defaultProps = {
  digitalCertificate: {},
}

export default CarControlDescription
